import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const putWorkspace = async (data) => {
  const response = await axios({
    url: 'config/workspace',
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: data,
  });
  return response.data;
};

const usePutWorkspace = () => {
  return useMutation((data) => putWorkspace(data));
};

export default usePutWorkspace;
